module.exports = __webpack_public_path__ + "img/laboratorio_3-4_1536.632e1a35.webp";